export default "{\n    \"title\": \"Editar mantenimiento preventivo\",\n    \"name\": \"Nombre\",\n    \"submitLabel\": \"Guardar\"\n}\n"